/*!
 * RENOVAID Info-Tooltip ("i") — globales Script
 * ------------------------------------------------
 * Wird via <script src="{{ 'renovaid-tooltip.js' | asset_url }}" defer>
 * in layout/theme.liquid eingebunden. Läuft damit auf JEDER Seite —
 * unabhängig davon, ob die Produktkacheln server-seitig oder per AJAX
 * (z.B. <product-recommendations> auf der Produktseite, Search-&-Discovery
 * Empfehlungs-Slider) nachgeladen werden.
 *
 * Browser-Grundregel: <script>-Tags, die via innerHTML in den DOM gelangen,
 * werden NICHT ausgeführt. Inline-Script im Snippet würde auf der Produktseite
 * deshalb tot bleiben — externes Script vermeidet das Problem komplett.
 *
 * HTML (button + popover) und CSS bleiben weiterhin im Snippet
 * snippets/product-info-tooltip.liquid.
 */
(function () {
  if (window.__riInfoTooltipInit) return;
  window.__riInfoTooltipInit = true;

  var openPopover = null;
  var openTrigger = null;
  var backdrop = null;
  var mq = window.matchMedia('(max-width: 749px)');

  function anchorTriggers() {
    var triggers = document.querySelectorAll('.ri-info-trigger');
    for (var i = 0; i < triggers.length; i++) {
      var trigger = triggers[i];
      var card = trigger.closest('.card-wrapper, .product-card-wrapper');
      if (!card) card = trigger.closest('.card');
      if (!card) continue;
      if (getComputedStyle(card).position === 'static') {
        card.style.position = 'relative';
      }
      if (trigger.parentElement !== card) {
        card.appendChild(trigger);
      }
    }
  }

  function portalPopovers() {
    var pops = document.querySelectorAll('.ri-popover');
    for (var i = 0; i < pops.length; i++) {
      var pop = pops[i];
      if (pop.parentNode !== document.body && !pop.hasAttribute('data-ri-portaled')) {
        document.body.appendChild(pop);
        pop.setAttribute('data-ri-portaled', '');
      }
    }
  }

  function ensureBackdrop() {
    if (backdrop) return backdrop;
    backdrop = document.createElement('div');
    backdrop.className = 'ri-backdrop';
    backdrop.addEventListener('click', close);
    document.body.appendChild(backdrop);
    return backdrop;
  }

  function close() {
    if (!openPopover) return;
    var pop = openPopover;
    var trg = openTrigger;
    pop.classList.remove('is-open', 'ri-popover--sheet');
    pop.style.cssText = '';
    var arrow = pop.querySelector('.ri-popover__arrow');
    if (arrow) arrow.style.cssText = '';
    pop.hidden = true;
    if (trg) {
      trg.setAttribute('aria-expanded', 'false');
      try { trg.focus({ preventScroll: true }); } catch (e) { try { trg.focus(); } catch (e2) {} }
    }
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.classList.remove('ri-chat-hidden');
    openPopover = null;
    openTrigger = null;
  }

  function positionDesktop(trigger, pop) {
    pop.classList.remove('ri-popover--sheet');
    pop.hidden = false;
    pop.style.position = 'fixed';
    pop.style.visibility = 'hidden';
    pop.style.left = '0px';
    pop.style.top = '0px';

    var tRect = trigger.getBoundingClientRect();
    var pRect = pop.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var vh = document.documentElement.clientHeight;
    var margin = 8;
    var gap = 10;

    var left = tRect.left + tRect.width / 2 - pRect.width / 2;
    var top = tRect.top - pRect.height - gap;
    var arrowOnBottom = true;

    if (top < margin) {
      top = tRect.bottom + gap;
      arrowOnBottom = false;
    }
    if (left < margin) left = margin;
    if (left + pRect.width > vw - margin) left = vw - margin - pRect.width;
    if (top + pRect.height > vh - margin) top = Math.max(margin, vh - margin - pRect.height);

    pop.style.left = left + 'px';
    pop.style.top = top + 'px';
    pop.style.visibility = '';

    var arrow = pop.querySelector('.ri-popover__arrow');
    if (arrow) {
      var arrowLeftPx = tRect.left + tRect.width / 2 - left - 6;
      arrowLeftPx = Math.max(10, Math.min(arrowLeftPx, pRect.width - 22));
      arrow.style.left = arrowLeftPx + 'px';
      if (arrowOnBottom) {
        arrow.style.bottom = '-7px';
        arrow.style.top = 'auto';
        arrow.style.transform = 'rotate(225deg)';
      } else {
        arrow.style.top = '-7px';
        arrow.style.bottom = 'auto';
        arrow.style.transform = 'rotate(45deg)';
      }
    }

    requestAnimationFrame(function () { pop.classList.add('is-open'); });
  }

  function positionMobile(pop) {
    pop.style.cssText = '';
    var arrow = pop.querySelector('.ri-popover__arrow');
    if (arrow) arrow.style.cssText = '';
    pop.classList.add('ri-popover--sheet');
    pop.hidden = false;
    void pop.offsetHeight;
    pop.classList.add('is-open');
    ensureBackdrop().classList.add('is-open');
  }

  function open(trigger) {
    if (openPopover) close();
    var id = trigger.getAttribute('aria-controls');
    if (!id) return;
    var pop = document.getElementById(id);
    if (!pop) return;

    if (pop.parentNode !== document.body) {
      document.body.appendChild(pop);
      pop.setAttribute('data-ri-portaled', '');
    }

    openPopover = pop;
    openTrigger = trigger;
    trigger.setAttribute('aria-expanded', 'true');

    if (mq.matches) {
      positionMobile(pop);
      document.body.classList.add('ri-chat-hidden');
    } else {
      positionDesktop(trigger, pop);
    }

    var closeBtn = pop.querySelector('[data-ri-close]');
    if (closeBtn) {
      try { closeBtn.focus({ preventScroll: true }); } catch (e) { try { closeBtn.focus(); } catch (e2) {} }
    }
  }

  function triggerUnderPoint(e) {
    if (!document.elementsFromPoint) return null;
    var stack = document.elementsFromPoint(e.clientX, e.clientY);
    for (var i = 0; i < stack.length; i++) {
      var el = stack[i];
      if (!el) continue;
      if (el.classList && el.classList.contains('ri-info-trigger')) return el;
      if (el.closest) {
        var maybe = el.closest('.ri-info-trigger');
        if (maybe) return maybe;
      }
    }
    return null;
  }

  function onClick(e) {
    var trigger = e.target.closest && e.target.closest('.ri-info-trigger');
    if (!trigger) trigger = triggerUnderPoint(e);
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      if (openTrigger === trigger) {
        close();
      } else {
        open(trigger);
      }
      return;
    }
    var closer = e.target.closest && e.target.closest('[data-ri-close]');
    if (closer && openPopover && openPopover.contains(closer)) {
      e.preventDefault();
      e.stopPropagation();
      close();
      return;
    }
    if (openPopover && !(e.target.closest && e.target.closest('.ri-popover'))) {
      close();
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape' && openPopover) {
      e.stopPropagation();
      close();
    }
  }

  function onScrollClose() {
    if (!openPopover) return;
    if (mq.matches) return;
    close();
  }

  function onResizeClose() {
    if (!openPopover) return;
    if (mq.matches) return;
    close();
  }

  document.addEventListener('click', onClick, true);
  document.addEventListener('keydown', onKeydown);
  window.addEventListener('scroll', onScrollClose, true);
  window.addEventListener('resize', onResizeClose);

  function init() {
    anchorTriggers();
    portalPopovers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if ('MutationObserver' in window) {
    var reinitScheduled = false;
    function scheduleReinit() {
      if (reinitScheduled) return;
      reinitScheduled = true;
      requestAnimationFrame(function () {
        reinitScheduled = false;
        if (openPopover && openTrigger && !document.body.contains(openTrigger)) {
          close();
        }
        anchorTriggers();
        portalPopovers();
      });
    }
    var mo = new MutationObserver(scheduleReinit);
    if (document.body) {
      mo.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        mo.observe(document.body, { childList: true, subtree: true });
      });
    }
  }
})();